import api, {
  PaginateRequest, PaginateResponse, ResponseCallback
} from '../services/api.service'
import { ReportPaginateResponseData } from '../utils/reportPaginate.util'

export interface InsAndOutsReportPaginateRequest
  extends InsAndOutsReportExportRequest, PaginateRequest {}

export type InsAndOutsReportPaginateResponse = PaginateResponse<ReportPaginateResponseData[]>

export interface InsAndOutsReportExportRequest {
  startAt?: string
  endAt?: string
  item?: number
}

const routes = {
  paginateReport: '/insAndOuts/report/paginate',
  exportReport: '/insAndOuts/report/export'
}

export default {
  paginateReport (
    params: InsAndOutsReportPaginateRequest,
    callback: ResponseCallback<InsAndOutsReportPaginateResponse>
  ) {
    api.get(routes.paginateReport, params, callback)
  },

  exportReport (
    params: InsAndOutsReportExportRequest,
    callback: ResponseCallback<Blob>
  ) {
    api.get(routes.exportReport, params, callback)
  }
}
